import React from 'react'
import { SkeletonBlock, SkeletonBody } from './TileSkeleton.styles'

interface TileSkeletonProps {
	/** How many shimmer rows to render (default 3). */
	rows?: number
}

/**
 * A per-tile loading placeholder: a few shimmer blocks filling the tile body
 * while that tile's own query is still in flight. Keeps a cold visit from
 * flashing zero-states before data arrives (review finding C2).
 */
const TileSkeleton: React.FC<TileSkeletonProps> = ({ rows = 3 }) => (
	<SkeletonBody aria-hidden="true" data-testid="tile-skeleton">
		{Array.from({ length: rows }, (_, i) => (
			<SkeletonBlock key={i} $width={i === rows - 1 ? '60%' : '100%'} />
		))}
	</SkeletonBody>
)

export default TileSkeleton
